import React from 'react';
import Loading from '../Loading';
// @ts-ignore
import styles from './FullPageLoading.module.scss';

const FullPageLoading: React.FC = () => (
	<div className={styles.pageLoader}>
		<div className='page-loader-wrapper'>
			<div className='w-100'>
				<Loading />
			</div>
		</div>
	</div>
);

export default FullPageLoading;
